import { render, staticRenderFns } from "./AdminBUFormCreate.vue?vue&type=template&id=a9f66fbc&lang=pug"
import script from "./AdminBUFormCreate.vue?vue&type=script&lang=js"
export * from "./AdminBUFormCreate.vue?vue&type=script&lang=js"
import style0 from "./AdminBUFormCreate.vue?vue&type=style&index=0&id=a9f66fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports